/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setScrollFlag.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * 初期設定
 */
const html = document.documentElement;

/**
 * スクロール上下判定
 */
var sc = (function () {
  let scrollElement = 'scrollingElement' in document ? document.scrollingElement : document.documentElement;
  let scrollPoint, prePoint, flag;
  return function () {
    scrollPoint = scrollElement.scrollTop;
    flag = prePoint > scrollPoint ? true : false;
    prePoint = scrollPoint;
    return flag;
  }
})();

/**
 * ヘッダー変形
 */
const setScrollFlag = () => {
  const transform = () => {
    sc() ? html.classList.remove('--bnr-hidden') : html.classList.add('--bnr-hidden');
  }
  window.addEventListener("scroll", transform);
}

/**
 * ActionTo.
 */
export {
  setScrollFlag
}